import {Provider} from '@angular/core';
import {UuidPort} from '@shared/application/uuid/uuid.port';
import {UuidAdapter} from '@shared/infrastructure/uuid/uuid.adapter';

export const UuidProvider: Provider = {
  provide: UuidPort,
  useClass: UuidAdapter
}
